import { render, staticRenderFns } from "./IcoCompetencyGroup.vue?vue&type=template&id=2997f7a3"
import script from "./IcoCompetencyGroup.vue?vue&type=script&lang=js"
export * from "./IcoCompetencyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports